import { Box, Grid, Hidden, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import IntegrationButton from "./IntegrationButton";
import { useHasScope } from "../../../config/globalConfig";
import { CBAuth, CBIntegrationButtonLink, CBOmissionType, IFormValues } from "../types";
import { useFormContext, useWatch } from "react-hook-form";

const ActionsBar = () => {

    const { t } = useTranslation("customerbase");
    const { id } = useParams();
    const { control } = useFormContext<IFormValues>();
    const currentBPCode = useWatch<IFormValues, 'cbDetails.bpCode'>({
        control: control,
        name: "cbDetails.bpCode"
    });
    const hasScope = useHasScope;

    return (
        <Box p={1}>
            <Hidden lgDown>
                <Stack direction="row" justifyContent="space-between" alignItems="center" p={2} columnGap={1}>
                        {hasScope(CBAuth.VIEW_BOOKINGS) && <IntegrationButton 
                            linkTo={CBIntegrationButtonLink.BOOKINGS + `?customerId=${id}`}
                            label={t('labels.viewBookings')}
                            
                        />}
                        {hasScope(CBAuth.VIEW_PAYMENTS) && <IntegrationButton 
                            linkTo={CBIntegrationButtonLink.PAYMENTS + `?customerId=${currentBPCode}`}
                            label={t("labels.viewPayments")}
                            isDisabled={!currentBPCode || currentBPCode == CBOmissionType.OMISSION_DASH}
                        />}
                        {hasScope(CBAuth.VIEW_INVOICES) && <IntegrationButton 
                            linkTo={CBIntegrationButtonLink.INVOICES + `?customerId=${currentBPCode}`} 
                            label={t("labels.viewInvoices")}
                            isDisabled={!currentBPCode || currentBPCode == CBOmissionType.OMISSION_DASH}
                        />}
                        {hasScope(CBAuth.VIEW_RENTAL_AGREEMENTS) && <IntegrationButton 
                            linkTo={CBIntegrationButtonLink.RA + `?customerId=${id}`}  
                            label={t("labels.viewRentalAgreements")}
                        />}
                        
                        {hasScope(CBAuth.VIEW_FINES) && <IntegrationButton 
                            linkTo={CBIntegrationButtonLink.FINES + `?customerId=${id}`} 
                            label={t("labels.viewFines")}
                        />}
                        
                        {hasScope(CBAuth.VIEW_DAMAGES) && <IntegrationButton 
                            linkTo={CBIntegrationButtonLink.DAMAGES + `?customerId=${id}`}
                            label={t("labels.viewDamages")}
                        />}

                        {hasScope(CBAuth.VIEW_SUBSCRIPTIONS) && <IntegrationButton 
                            linkTo={CBIntegrationButtonLink.SUBSCRIPTIONS + `?customerId=${id}`} 
                            label={t("labels.viewSubscriptions")}
                        />}
                        
                        {hasScope(CBAuth.VIEW_VOUCHERS) && <IntegrationButton 
                            linkTo={CBIntegrationButtonLink.VOUCHERS + `?customerId=${id}`} 
                            label={t("labels.viewVouchers")}
                        />}
                        {hasScope(CBAuth.VIEW_OUTSTANDINGS) && <IntegrationButton 
                            linkTo={CBIntegrationButtonLink.OUTSTANDING + `?customerId=${currentBPCode}`}
                            label={t("labels.viewOutstanding")}
                            isDisabled={!currentBPCode || currentBPCode == CBOmissionType.OMISSION_DASH}
                        />}
                        
                </Stack>
            </Hidden>
            <Hidden lgUp>
                <Grid container alignItems={"baseline"} flexDirection={"column"} alignContent={"flex-start"} >
                    <Grid item container rowSpacing={1}>
                        {hasScope(CBAuth.VIEW_BOOKINGS) && <Grid item sm={3} xs={6}>
                            <IntegrationButton 
                                linkTo={CBIntegrationButtonLink.BOOKINGS + `?customerId=${id}`}
                                label={t('labels.viewBookings')}
                            />
                        </Grid>}
                        {hasScope(CBAuth.VIEW_PAYMENTS) && <Grid item sm={3} xs={6}>
                            <IntegrationButton 
                                linkTo={CBIntegrationButtonLink.PAYMENTS + `?customerId=${currentBPCode}`}
                                label={t("labels.viewPayments")}
                                isDisabled={!currentBPCode || currentBPCode == CBOmissionType.OMISSION_DASH}
                            />
                        </Grid>}
                        {hasScope(CBAuth.VIEW_INVOICES) && <Grid item sm={3} xs={6}>
                            <IntegrationButton 
                                linkTo={CBIntegrationButtonLink.INVOICES + `?customerId=${currentBPCode}`} 
                                label={t("labels.viewInvoices")}
                                isDisabled={!currentBPCode || currentBPCode == CBOmissionType.OMISSION_DASH}
                            />
                        </Grid>}
                        {hasScope(CBAuth.VIEW_RENTAL_AGREEMENTS) && <Grid item sm={3} xs={6}>
                            <IntegrationButton 
                                linkTo={CBIntegrationButtonLink.RA + `?customerId=${id}`}  
                                label={t("labels.viewRentalAgreements")}
                            />
                        </Grid>}
                        {hasScope(CBAuth.VIEW_FINES) && <Grid item sm={3} xs={6}>
                            <IntegrationButton 
                                linkTo={CBIntegrationButtonLink.FINES + `?customerId=${id}`} 
                                label={t("labels.viewFines")}
                            />
                        </Grid>}
                        {hasScope(CBAuth.VIEW_DAMAGES) && <Grid item sm={3} xs={6}>
                            <IntegrationButton 
                                linkTo={CBIntegrationButtonLink.DAMAGES + `?customerId=${id}`}
                                label={t("labels.viewDamages")}
                            />
                        </Grid>}
                        {hasScope(CBAuth.VIEW_SUBSCRIPTIONS) && <Grid item sm={3} xs={6}>
                            <IntegrationButton 
                                linkTo={CBIntegrationButtonLink.SUBSCRIPTIONS + `?customerId=${id}`} 
                                label={t("labels.viewSubscriptions")}
                            />
                        </Grid>}
                        {hasScope(CBAuth.VIEW_VOUCHERS) && <Grid item sm={3} xs={6}>
                            <IntegrationButton 
                                linkTo={CBIntegrationButtonLink.VOUCHERS + `?customerId=${id}`} 
                                label={t("labels.viewVouchers")}
                            />
                        </Grid>}
                        {hasScope(CBAuth.VIEW_OUTSTANDINGS) && <Grid item sm={3} xs={6}>
                            <IntegrationButton 
                                linkTo={CBIntegrationButtonLink.OUTSTANDING + `?customerId=${id}`}
                                label={t("labels.viewOutstanding")}
                                isDisabled={!currentBPCode || currentBPCode == CBOmissionType.OMISSION_DASH}
                            />
                        </Grid>}
                    </Grid>
                </Grid>
            </Hidden>
        </Box>
    )
}

export default ActionsBar;